module.exports = __webpack_public_path__ + "img/email.4aff3d6c.png";